import { render } from "./index.vue?vue&type=template&id=7faf4708&scoped=true&ts=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7faf4708&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faf4708"]])

export default __exports__